import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var LoginService = /** @class */ (function () {
    function LoginService(http) {
        this.http = http;
    }
    LoginService.prototype.checkCredential = function (body) {
        return this.http.post('login', body);
    };
    LoginService.prototype.checkUser = function (email) {
        return this.http.post("checkForRegisteredEmailId", email);
    };
    LoginService.prototype.verifyOtp = function (data) {
        return this.http.post("verifyOtp", data);
    };
    LoginService.prototype.resetPassword = function (data) {
        return this.http.post("resetPassword", data);
    };
    LoginService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginService_Factory() { return new LoginService(i0.ɵɵinject(i1.HttpClient)); }, token: LoginService, providedIn: "root" });
    return LoginService;
}());
export { LoginService };
